import { ProtectedRoute } from './ProtectedRoute';

interface AdminGateProps {
  children: React.ReactNode;
}

export const AdminGate = ({ children }: AdminGateProps) => (
  <ProtectedRoute>
    {children}
  </ProtectedRoute>
);